import React, { useEffect, useState, useContext } from 'react';
import T_Error from "../404";
import { Button, Tooltip, Row, Col, Divider, Spin, Space, DatePicker, Select, Checkbox, Modal, Form, message, Input, Table, Tag, Popconfirm, InputNumber, Switch } from 'antd';

import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { PictureOutlined, SendOutlined, ReloadOutlined, FileOutlined, PlusOutlined } from "@ant-design/icons";
import AppContext from "../AppContext";

import { onCreateHoliday, onGetHoliday, onUpdateHoliday } from '../../Controller/Management/HolidaysManagement';
import moment from 'moment';

export default function HolidayManagement(prop) {


    const { Option } = Select;
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance
    const [isModalVisible, setisModalVisible] = useState(false);
    const [currentyear, setcurrentyear] = useState(moment().year())
    const [disableSelect, setDisableSelect] = useState(false);

    const [holidaylist, setHolidaylist] = useState([]);
    const [isActive, setIsActive] = useState(false);
    const { TextArea } = Input;
    const [holidayform] = Form.useForm();
    const [btndisable, setBtnDisable] = useState(false);
    const global = useContext(AppContext)
    const userid = global.UserIdentity.userid;

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 14 },
        },
    };

    //===== USE EFFECT ========
    useEffect(() => {
        onRefresh();
    }, []);

     //===== USE EFFECT ========
     useEffect(() => {
        onRefresh();
    }, [currentyear]);

    //===== FUNCTION =====
    const onRefresh = () => {

        
        onGetHoliday({
            yearint: [currentyear]
        })
            .then(val => {
                console.log("get holidays .>>>", val)
                setHolidaylist(val.data);

                return val;
            })
            .catch(err => {
                console.log("get holidays rer>>>", err)
                message.error(err.msg);
                setIsMaintenance(true);
            });
    }

    const handleEdit = (record) => {
        // Handle the edit logic here
        var tempdata = { ...record }
        tempdata.date = moment(tempdata.date)
        if (tempdata.allcompany == 1) {
            setDisableSelect(true)
        }
        else {
            setDisableSelect(false)
        }
        console.log('Edit', tempdata);
        holidayform.setFieldsValue(tempdata)
        setisModalVisible(true)

    };

    const handleDelete = (record) => {
        // Handle the delete logic here
        console.log('Delete', record);


        var newrecord = {
            _id: record._id,
            active: 0,
            editby: userid
        }
        onUpdateHoliday(newrecord)
            .then(val => {
                console.log("update holidays .>>>", val)
                onRefresh()

                return val;
            })
            .catch(err => {

                message.error(err.msg);
                setIsMaintenance(true);
            });
    }





    const tablecolumns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            defaultSortOrder: 'ascend',
            render: (dateData) => (


                <span>{moment(dateData).format("YYYY-MM-DD, ddd")}</span>
                //<span>{dateData}</span>

            )
        },
        {
            title: 'Company List',
            dataIndex: 'companylist',
            key: 'companylist',
            render: (companylist, record) => (
                <span>
                    {
                        record.allcompany == 1 ?
                            <Tag color={'green'}>
                                {'ALL'}
                            </Tag>
                            :
                            companylist.map((company, index) => (
                                <Tag key={index} color={'blue'}>
                                    {company}
                                </Tag>
                            ))}
                </span>
            ),
        },
        {
            title: 'Remark',
            dataIndex: 'remark',
            key: 'remark',
        },
        // {
        //     title: 'Active',
        //     dataIndex: 'active',
        //     key: 'active',
        //     render: (active, record) => (
        //       <Switch
        //         checked={active === 1}
        //         onChange={(checked) => handleSwitchChange(record, checked)}
        //       />
        //     ),
        //   },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <Space>
                    <EditOutlined onClick={() => handleEdit(record)} style={{ cursor: 'pointer', color: 'blue' }} />
                    <Popconfirm
                        title="Are you sure you want to delete this record?"
                        onConfirm={() => handleDelete(record)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const onFinish = (values) => {
        console.log('Received values:', values);

        if (values.allcompany == true) {
            values.companylist = []
            values.allcompany = 1
        }
        else {
            values.allcompany = 0
        }

        const savedata =
        {
            title: values.title,
            yearint: moment(values.date).year(),
            date: moment(values.date).format("YYYY/MM/DD"),
            companylist: values.companylist,
            remark: values.remark,
            active: values.active,
            allcompany: values.allcompany

        }
        savedata.editby = userid
        console.log("savedata >>>>", savedata)
        if (values._id == undefined) {
            savedata.createdby = userid

            savedata.active = 1

            return onCreateHoliday(savedata)
                .then(result => {

                    console.log("save result >>>>", result)
                    if (result.msg == 'Create holiday successfully') {
                        message.success("Holiday Saved")

                        onRefresh()
                        holidayform.resetFields();
                    }
                    else {
                        message.error(result.msg)
                    }
                    setisModalVisible(false);
                });
        }
        else {
            savedata._id = values._id
            return onUpdateHoliday(savedata)
                .then(result => {

                    console.log("update result >>>>", result)
                    if (result.msg == 'update holiday successfully') {
                        message.success("Holiday Updated")

                        onRefresh()
                        holidayform.resetFields();
                    }
                    else {
                        message.error(result.msg)
                    }
                    setisModalVisible(false);
                });
        }


        // Add logic to handle the submitted values
    };


    const handleAllCheckboxChange = (e) => {
        setDisableSelect(e.target.checked);

    };

    const handleActiveCheckboxChange = (e) => {
        setIsActive(e.target.checked);
    };

    const handleCancel = () => {

        holidayform.resetFields()

        setisModalVisible(false);
    }

    const handleYearnumber = (e) => {

        setcurrentyear(e)
        console.log('Year >>>', e)
    }

    return (
        <>
            {(() => {
                if (isMaintenance) {
                    return (<T_Error />)
                }
                else {
                    return (
                        <>
                            <Row justify="start">
                                <Divider>{prop.title ?? "."}</Divider>
                            </Row>
                            <Row>
                                <Col span={3}>
                                    <div style={{ float: "right" }}>
                                       Year : <InputNumber onChange={handleYearnumber} defaultValue={moment().year()}/>
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <div style={{ float: "right" }}>
                                        <Space size={2}>
                                            <Tooltip placement="bottom" title={"New Holiday"}>
                                                <Button onClick={(e) => { setisModalVisible(true); setDisableSelect(false) }}><PlusOutlined /></Button>
                                            </Tooltip>
                                            <Button>{btndisable ? <Spin /> : <ReloadOutlined />}</Button>
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <Table columns={tablecolumns} dataSource={holidaylist} pagination={false}/>
                            <Modal
                                title={"Holiday"}
                                visible={isModalVisible}
                                destroyOnClose={true}
                                style={{ maxWidth: "80%" }}
                                bodyStyle={{ overflow: "auto", maxHeight: "70vh" }}
                                onOk={() => {
                                    holidayform
                                        .validateFields()
                                        .then((values) => {
                                            console.log("finish values >>>>", values)
                                            onFinish(values);
                                        })
                                        .catch((info) => {
                                            console.log('Validate Failed:', info);
                                        });
                                }}
                                onCancel={handleCancel}
                                okText="Submit"
                            >
                                <Form form={holidayform} onFinish={onFinish}>
                                    <Form.Item
                                        name="_id"
                                        style={{ display: "none" }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name="createdby"
                                        style={{ display: "none" }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name="editby"
                                        style={{ display: "none" }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name="title"
                                        label="Title"
                                        {...formItemLayout}
                                        rules={[{ required: true, message: 'Please input the title!' }]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name="date"
                                        label="Date"
                                        {...formItemLayout}
                                        rules={[{ required: true, message: 'Please select the date!' }]}
                                    >
                                        <DatePicker />
                                    </Form.Item>

                                    <Form.Item
                                        name="companylist"
                                        label="Company"
                                        {...formItemLayout}
                                    >
                                        <Select
                                            mode="multiple"
                                            disabled={disableSelect}>
                                            <Option value="NAX">NAX</Option>

                                            {/* Add other company options as needed */}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        {...formItemLayout}
                                        name="remark" label="Remark">
                                        <Input.TextArea rows={4} />
                                    </Form.Item>

                                    <Form.Item name="allcompany" label="ALL" valuePropName="checked"  {...formItemLayout}>
                                        <Checkbox onChange={handleAllCheckboxChange} />
                                    </Form.Item>

                                    {/* <Form.Item label="active" name="activeCheckbox" valuePropName="checked"  {...formItemLayout}>
                                        <Checkbox onChange={handleActiveCheckboxChange} />
                                    </Form.Item> */}
                                </Form>
                            </Modal>
                        </>
                    )
                }
            })()}
        </>
    )

}